import { StarDecorations } from 'components/ui/StarDecorations';
import { FormDataELBB } from 'types/iniciativa-elbb';

interface ResultCardELBBProps {
  formData: FormDataELBB;
  onBack: () => void;
  onConfirm: () => void;
  gestores?: any[];
  isSubmitting?: boolean;
}

export function ResultCardELBB({ formData, onBack, onConfirm, gestores = [], isSubmitting = false }: ResultCardELBBProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-bb via-blue-bb-1 to-blue-bb-5 overflow-hidden relative">
      <StarDecorations count={20} density="low" />

      {/* Confirmation Content */}
      <div className="flex flex-col items-center justify-center min-h-[80vh] px-6 mt-4">
        <div className="bg-white-bb rounded-2xl p-8 max-w-4xl w-full shadow-2xl">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">✅</div>
            <h1 className="text-3xl font-bold text-blue-bb-3 mb-4">
              Confirme os Dados da Iniciativa
            </h1>
            <p className="text-gray-bb-2 text-lg">
              Revise as informações antes de finalizar o cadastro.
            </p>
          </div>

          <div className="bg-gray-bb-3 rounded-xl p-6 mb-6">
            <h2 className="text-xl font-bold text-blue-bb-3 mb-4">Resumo da Iniciativa:</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <strong className="text-gray-bb-1">Título:</strong>
                <p className="text-gray-bb-2">{formData.TITULO}</p>
              </div>
              <div>
                <strong className="text-gray-bb-1">Categoria:</strong>
                <p className="text-gray-bb-2">{formData.CATEGORIA}</p>
              </div>
              <div>
                <strong className="text-gray-bb-1">Perspectiva ECBB:</strong>
                <p className="text-gray-bb-2">{formData.CATEGORIA}</p>
              </div>
              <div>
                <strong className="text-gray-bb-1">Período:</strong>
                <p className="text-gray-bb-2">{formData.inicioEntrega} - {formData.conclusaoEntrega}</p>
              </div>
              {formData.GESTOR_ATUAL_NOME && (
                <div>
                  <strong className="text-gray-bb-1">Gestor:</strong>
                  <p className="text-gray-bb-2">{formData.GESTOR_ATUAL_NOME}</p>
                </div>
              )}
              <div>
                <strong className="text-gray-bb-1">Participantes:</strong>
                <p className="text-gray-bb-2">{formData.participantes.length} pessoas</p>
              </div>
            </div>
            {formData.participantes.length > 0 && (
              <div className="mt-4">
                <strong className="text-gray-bb-1">Equipe:</strong>
                <div className="flex flex-wrap gap-2 mt-2">
                  {formData.participantes.map((p, i) => (
                    <span key={i} className="bg-blue-bb-6 text-blue-bb-3 px-3 py-1 rounded-full text-sm">
                      {p.name || p.extra?.nome || p._id} ({p._id})
                    </span>
                  ))}
                </div>
              </div>
            )}
            {formData.DESCRICAO && (
              <div className="mt-4">
                <strong className="text-gray-bb-1">Descrição:</strong>
                <p className="text-gray-bb-2 mt-1">{formData.DESCRICAO}</p>
              </div>
            )}
            {formData.RESULTADO && (
              <div className="mt-4">
                <strong className="text-gray-bb-1">Resultado:</strong>
                <p className="text-gray-bb-2 mt-1">{formData.RESULTADO}</p>
              </div>
            )}
          </div>

          <div className="flex justify-center gap-4">
            <button 
              onClick={onBack} 
              className="bg-gray-bb-2 text-white-bb px-8 py-3 rounded-lg font-bold hover:bg-gray-bb-1 transition-all"
            >
              Voltar
            </button>
            <button 
              onClick={onConfirm}
              disabled={isSubmitting}
              className={`bg-yellow-bb text-blue-bb-3 px-8 py-3 rounded-lg font-bold transition-all ${
                isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'
              }`}
            >
              {isSubmitting ? 'Enviando...' : 'Confirmar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
